import CloseIcon from 'common/components/svg-icon/close';
import WatchASLogo from 'common/components/watch-as-logo';
import styles from './styles.less';
import { observer } from 'mobx-react';


function MobileAppPrompt(props) {
    return (
        <div className={ props.className }>
            <div className={ styles.root }>
                <header className={ styles.header }>
                    <WatchASLogo
                        className={ styles.watchASLogo }
                        logoOnly
                    />
                    <button
                        className={ styles.closeButton }
                        onClick={ props.onClose }>
                        <CloseIcon className={ styles.closeIcon } />
                    </button>
                </header>
                <div className={ styles.content }>
                    <p className={ styles.message }>This episode requires a cable subscription. Wanna use our app to watch it?</p>
                </div>
                <footer className={ styles.footer }>
                    <button
                        className={ styles.responseButton }
                        onClick={ () => props.onResponse(false) }>
                        No
                    </button>
                    <button
                        className={ styles.responseButton }
                        onClick={ () => props.onResponse(true) }>
                        Yes
                    </button>
                </footer>
            </div>
            <div className={ styles.background }></div>
        </div>
    );
}

MobileAppPrompt.propTypes = {
    onClose: React.PropTypes.func.isRequired,
    onResponse: React.PropTypes.func.isRequired
};


export default observer(MobileAppPrompt);



// WEBPACK FOOTER //
// ./src/common/components/mobile-app-prompt/index.js